export default __webpack_public_path__ + "static/media/PropertyDev_IMG-NationalCamp.c8f34b48.png";